import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'
import {
  ContactMainContainer,
  ContactContainer,
  ContactImageContainer,
  ContactImage,
  ContactContent,
  ContactAddress,
  ContactTelephone,
  ContactTitle,
} from './styles'

const ContactPageLayout = ({ query }) => {
  return (
    <ContactMainContainer>
      {query?.body?.[0]?.items?.length > 0 &&
        query?.body?.[0]?.items?.map((element, index) => {
          return (
            <>
              <ContactContainer key={index} reverseOrder={index === 1}>
                {element?.contact_image?.localFile?.childImageSharp?.fluid ? (
                  <Fade distance="30px" bottom>
                    <ContactImageContainer>
                      <ContactImage
                        fluid={
                          element?.contact_image?.localFile?.childImageSharp
                            ?.fluid
                        }
                        alt={element?.contact_image?.alt}
                      />
                    </ContactImageContainer>
                  </Fade>
                ) : (
                  <></>
                )}
                <ContactContent>
                  {element?.contact_title?.text ? (
                    <Fade distance="30px" bottom>
                      <ContactTitle
                        as="h3"
                        type="h3"
                        reverseOrder={index === 1}
                      >
                        {element?.contact_title?.text}
                      </ContactTitle>
                    </Fade>
                  ) : (
                    <></>
                  )}
                  <Fade distance="30px" bottom>
                    <ContactAddress
                      as="p"
                      type="primary"
                      dangerouslySetInnerHTML={{
                        __html: element?.contact_details?.html,
                      }}
                      reverseOrder={index === 1}
                    ></ContactAddress>
                    <ContactTelephone>
                      <a href={`tel:+1${element?.contact_telephone?.text}`}>
                        {element?.contact_telephone?.text}
                      </a>
                    </ContactTelephone>
                  </Fade>
                </ContactContent>
              </ContactContainer>
            </>
          )
        })}
    </ContactMainContainer>
  )
}

ContactPageLayout.propTypes = {
  query: PropTypes.object.isRequired,
}

export default ContactPageLayout
